import {PropsWithChildren} from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';

import {AuthProvider} from '@/auth/providers/JWTProvider';
import {
    LayoutProvider,
    LoadersProvider,
    MenusProvider,
    SettingsProvider,
    SnackbarProvider,
    TranslationProvider
} from '@/providers';
import {HelmetProvider} from 'react-helmet-async';
import {UserProvider} from "@/contexts/UserContext.tsx";
import {StatisticProvider} from "@/contexts/StatisticContext.tsx";

const queryClient = new QueryClient();

const ProvidersWrapper = ({children}: PropsWithChildren) => {
    return (
        <QueryClientProvider client={queryClient}>
            <SnackbarProvider>
                <AuthProvider>
                    <SettingsProvider>
                        <TranslationProvider>
                            <HelmetProvider>
                                <LayoutProvider>
                                    <LoadersProvider>
                                        <UserProvider>
                                            <StatisticProvider>
                                                <MenusProvider>{children}</MenusProvider>
                                            </StatisticProvider>
                                        </UserProvider>
                                    </LoadersProvider>
                                </LayoutProvider>
                            </HelmetProvider>
                        </TranslationProvider>
                    </SettingsProvider>
                </AuthProvider>
            </SnackbarProvider>
        </QueryClientProvider>
    );
};

export {ProvidersWrapper};
